'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');


var _CompanyDescription = require('../CompanyDescription/CompanyDescription');var _CompanyDescription2 = _interopRequireDefault(_CompanyDescription);
var _AdditionalInformation = require('../AdditionalInformation/AdditionalInformation');var _AdditionalInformation2 = _interopRequireDefault(_AdditionalInformation);
var _components = require('../../../components');


var _appendLocale = require('../../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _CompanyBlock = require('./CompanyBlock.scss');var styles = _interopRequireWildcard(_CompanyBlock);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Helpers
var preventClick = function preventClick(e) {
  e.nativeEvent.stopImmediatePropagation();
  e.preventDefault();
};var

CompanyBlock = function (_Component) {_inherits(CompanyBlock, _Component);function CompanyBlock() {var _temp, _this, _ret;_classCallCheck(this, CompanyBlock);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      additionalInfoOpened: false }, _this.


    handleClick = function (evt) {
      if (!evt.target.dataset.type) {var _this$props =
        _this.props,locale = _this$props.locale,id = _this$props.company.id;

        var route = (0, _appendLocale2.default)(
        locale, '/company/' +
        id);

        _reactRouter.browserHistory.push(route);
      }
    }, _this.

    handleShowAdditionalInfo = function () {return _this.setState(function (state) {return Object.assign({},
        state, {
          additionalInfoOpened: !state.additionalInfoOpened });});}, _this.


    renderMobileContent = function (image, name, phoneNumber) {var
      translate = _this.props.translate;

      return (
        _react2.default.createElement('div', { className: styles.block },
          _react2.default.createElement('div', { onClick: _this.handleClick, className: styles.wrapper },
            _react2.default.createElement(_CompanyDescription2.default, {
                title: name,
                translate: translate,
                image: image },

              _react2.default.createElement('div', { className: styles.buttonWrapper },
                _react2.default.createElement('a', { href: 'tel:' + phoneNumber, 'data-type': 'link' },
                  translate('companyInPropertiesList', 'button')))))));






    }, _this.

    renderDesktopContent = function (image, title, phoneNumber) {var _this$props2 =
      _this.props,locale = _this$props2.locale,company = _this$props2.company,translate = _this$props2.translate,name = _this$props2.name;

      return (
        _react2.default.createElement('div', { className: styles.block },
          _react2.default.createElement(_reactRouter.Link, {
              className: styles.wrapper,
              target: '_blank',
              to: (0, _appendLocale2.default)(locale, '/company/' + company.id) },

            _react2.default.createElement(_CompanyDescription2.default, {
                title: name || title,
                translate: translate,
                image: image },

              _react2.default.createElement('div', {
                  className: styles.buttonWrapper,
                  onClick: preventClick },

                _react2.default.createElement('button', {
                    onClick: _this.handleShowAdditionalInfo,
                    type: 'button' },

                  translate('companyInPropertiesList', 'button')),

                _react2.default.createElement(_components.Modal, {
                    isOpen: _this.state.additionalInfoOpened,
                    onRequestClose: _this.handleShowAdditionalInfo,
                    translate: _this.props.translate,
                    isRtl: _this.props.isRtl,
                    className: styles.modal },

                  _react2.default.createElement(_AdditionalInformation2.default, {
                    name: name,
                    phoneNumber: phoneNumber,
                    image: image,
                    company: company,
                    translate: translate,
                    locale: locale,
                    onCLose: _this.handleShowAdditionalInfo })))))));







    }, _temp), _possibleConstructorReturn(_this, _ret);}CompanyBlock.prototype.

  render = function render() {var _props =
    this.props,isMobile = _props.isMobile,image = _props.image,name = _props.name,phoneNumber = _props.phoneNumber,company = _props.company,locale = _props.locale;
    var imageURL = image || company.image;
    var title = name || company.name[locale] || company.name.he;
    var phone = phoneNumber || company.phone_number;

    return isMobile ?
    this.renderMobileContent(imageURL, title, phone) :
    this.renderDesktopContent(imageURL, title, phone);
  };return CompanyBlock;}(_react.Component);exports.default = CompanyBlock;


CompanyBlock.propTypes = {
  name: _propTypes2.default.string,
  image: _propTypes2.default.string,
  phoneNumber: _propTypes2.default.string,
  company: _propTypes2.default.object,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyInPropertiesList/CompanyBlock/CompanyBlock.js
// module id = 2649
// module chunks = 0